// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WWfU","field":"styles_field__2sfeL","fieldCol":"styles_fieldCol__1ralP","diffCol":"styles_diffCol__3EFXY","diff":"styles_diff__3UM3o"};